import { navigateLeftStack } from '@/app/store/navigationSlice';
import { useRecentChats } from '@/features/chats/model/recentChat';
import { selectInviteUserCount } from '@/features/invite/model/selectors';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useChatFeature } from '../chatsRegistry';

const UX_CONFIG = {
   fetchDelay: 100,
   paginationTriggerDelay: 100,
   autoLoadCheckDelay: 100,
};

/**
 * ViewModel for RecentChatList.
 * Owns: navigation actions, feature gates, empty-state logic.
 * RecentChatList/index.jsx renders only.
 */
export const useRecentChatList = () => {
   const dispatch = useDispatch();

   const isGroupChatEnabled = useChatFeature('group-chat');
   const isSearchEnabled = useSelector(state => state.features.isRecentChatSearchEnabled ?? true);

   const isArchived = useSelector(state => state.settingsData.isKeepArchived);
   const inviteUserCount = useSelector(selectInviteUserCount);

   const recentChatsData = useRecentChats({
      scope: 'recentchat',
      fetchDelay: UX_CONFIG.fetchDelay,
   });

   const handleNewChat = useCallback(() => {
      dispatch(navigateLeftStack({ activeStack: 'chats', subStack: 'newChat' }));
   }, [dispatch]);

   const handleNewGroup = useCallback(() => {
      if (!isGroupChatEnabled) return;
      dispatch(navigateLeftStack({ activeStack: 'chats', subStack: 'newGroup' }));
   }, [dispatch, isGroupChatEnabled]);

   const handleOpenArchived = useCallback(() => {
      dispatch(navigateLeftStack({ activeStack: 'chats', subStack: 'archived' }));
   }, [dispatch]);

   const handleOpenMessageRequests = useCallback(() => {
      dispatch(navigateLeftStack({ activeStack: 'chats', subStack: 'messageRequests' }));
   }, [dispatch]);

   return {
      isGroupChatEnabled,
      isSearchEnabled,
      isArchived,
      handleNewChat,
      handleNewGroup,
      handleOpenArchived,
      handleOpenMessageRequests,
      inviteUserCount,
      UX_CONFIG,
      searchText: recentChatsData.searchText,
      ...recentChatsData,
   };
};
